import * as React from "react";
import WSProgressBar from "../../Workspace2/WSProgressBar";
// import FormGroup from "@mui/material/FormGroup";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
// import CardContent from "@mui/material/CardContent";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "../../Workspace2/sidebar.css";
import "./../..././../../../WorkSpace/SignUp2.css";
import { useHistory, useLocation, useParams } from "react-router";
import { motion } from "framer-motion";
import swal from "sweetalert";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllPresets } from "../../../redux/actions/workspace/actionAllPreset";

import {
  CreateIr,
  CreatePresetCheck,
  GetAllCompanyData,
  // GetAllProject,
  GetCheckedIR,
  UpdateStepStatus,
  fetchCoa,
  getCheckData,
  getWorkspace,
  getBookClosurePresets,
  CreateBookClosurePresetCheck
} from "../ApiServices/apiHandler";
import { useEffect } from "react";
import { useState } from "react";
import "../../../WorkSpace/font.css";
// for accordian
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// end accordian
import moment from "moment";
import WorkspaceHeader from "./WorkspaceHeader";
// import CircleIcon from '@mui/icons-material/Circle';
// import Checkbox from "@mui/material/Checkbox";

import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css"
import { ReactComponent as RightIcon } from "../../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as PervBtnIcon } from '../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import { ReactComponent as SearchIcon } from '../../../myfin_v2/assets/icons/search.svg'
import { ReactComponent as CloseGreyIcon } from "../../../myfin_v2/assets/icons/close_grey.svg";
import { ReactComponent as CircleCheckIcon } from '../../../myfin_v2/assets/icons/circle_check2.svg'


const label = { inputProps: { "aria-label": "Checkbox demo" } };

const ImportPresetV2 = (props) => {
  const dispatch = useDispatch();
  const all_presets = useSelector((state) => state.AllPresetsReducer);
  const user = JSON.parse(localStorage.getItem('user'));
  const [allProject, setAllProject] = useState([]);
  const [selected, setSelected] = useState([]);
  // const [selectedAllPreset, setSelectedPreset] = useState([]);
  const [checkStatus, setCheckStatus] = useState(false);
  const [allCompany, setAllCompany] = useState([]);
  const [allCoaData, setAllCoa] = useState([]);
  const [workspace, setWorkspace] = useState("");
  const [singleWorkspace, setSingleWorkspace] = useState([]);
  const [bookClosurePresets, setBookClosurePresets] = useState([]);
  const [selectedBookClosurePresets, setSelectedBookClosurePresets] = useState([]);
  const presetRequestIdRef = React.useRef(0);
  const bookClosureRequestIdRef = React.useRef(0);

  const { id } = useParams();
  let history = useHistory();
  const nextStep = async () => {
    try {
      const data = {
        steps: "step5",
        has_published: "draft",
        status: singleWorkspace.status,
        approver_id: singleWorkspace.approver_id,
        cancel_reason: singleWorkspace.cancel_reason,
      };
      const res = await UpdateStepStatus(id, data);
      if (res.status === 200) {
        history.push(`/inviteteammember/${id}`);
      }
    } catch (error) {
      console.log("error", error.message);
      return 0;
    }
  };
  const skipNext = async () => {
    history.push(`/inviteteammember/${id}`);
  };

  useEffect(() => {
    dispatch(fetchAllPresets(id));
    FetchProject();
    getIr();
    companyData();
    allCoa();
    getWorkspaceDetails();
    getSingleWorkspace();
    getBookClosurePreset();
  }, [dispatch, id]);

  useEffect(() => {
    if (all_presets?.isSuccess && all_presets?.response) {
      if (!searchText.trim()) setAllProject(all_presets.response);
    }
  }, [all_presets?.isSuccess, all_presets?.response]);

  const companyData = async () => {
    try {
      const res = await GetAllCompanyData();
      if (res.status === 200) {
        setAllCompany(res.data.getAllCompanyData);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };
  const FetchProject = async (search = "") => {
    const requestId = ++presetRequestIdRef.current;
    try {
      const auth = localStorage.getItem("auth_token");
      const headers = { "x-auth-token": auth };
      const res = await axios.get(`/api/v1/presets/list-presets`, {
        headers,
        params: search ? { search } : {},
      });
      const list =
        res?.data?.project ||
        res?.data?.presets_list ||
        res?.data?.presets ||
        res?.data?.preset_list ||
        res?.data?.data ||
        (Array.isArray(res?.data) ? res?.data : []);
      if (requestId === presetRequestIdRef.current && Array.isArray(list)) {
        setAllProject(list);
      }
    } catch (error) {
      console.log("error fetching presets", error);
    }
  };
  const getSingleWorkspace = async () => {
    const res = await getWorkspace(id);
    if (res.status === 200) {
      setSingleWorkspace(res.data?.getworkspace[0])
    }
  }

  const getBookClosurePreset = async () => {
    const res = await getBookClosurePresets();
    if (res.status === 200) {
      setBookClosurePresets(res.data?.presets)
    }
  }

  const handleSelectClick = async () => {
    try {
      if (allProject?.length > 0) {
        const newSelecteds = allProject.map((n) => n._id);
        setSelected(newSelecteds);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleSelectAllClick = async () => {
    try {
      if (allProject?.length > 0) {
        const newSelecteds = allProject.map((n) => n._id);
        setSelected(newSelecteds);
        // AllIr.push(Ir);
        let data = {
          w_id: id,
          all_Preset_checked: newSelecteds,
        };
        const res = await CreatePresetCheck(data);
        if (res.status === 200) {
          setCheckStatus(true);
          getIr();
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleSelectAllBookClosurePresets = async () => {
    try {
      if (bookClosurePresets?.length > 0) {
        const newSelecteds = bookClosurePresets.map((n) => n._id);
        setSelectedBookClosurePresets(newSelecteds);
        // AllIr.push(Ir);
        let data = {
          w_id: id,
          all_checked_bookclosure_presets: newSelecteds,
        };
        const res = await CreateBookClosurePresetCheck(data);
        if (res.status === 200) {
          setCheckStatus(true);
          getIr();
          swal("Success","Presets Imported Sucessfully","success");
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const getIr = async () => {
    try {
      const res = await GetCheckedIR(id);
      if (res.status === 200) {
        setSelected(res.data.getIR[0]?.all_preset_checked);
        setSelectedBookClosurePresets(res.data.getIR[0]?.all_checked_bookclosure_presets);
      }
    } catch (error) { }
  };

  const handleChangePreset = (field, e, id) => {
    const selectedIndex = selected?.indexOf(id);
    let Preset = [];
    if (selectedIndex === -1) {
      Preset = Preset.concat(selected, id);
    } else if (selectedIndex === 0) {
      Preset = Preset.concat(selected.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      Preset = Preset.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      Preset = Preset.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(Preset);
  };

  const handleBookClosurePreset = (field, e, id) => {
    const selectedIndex = selectedBookClosurePresets?.indexOf(id);
    let Preset = [];
    if (selectedIndex === -1) {
      Preset = Preset.concat(selectedBookClosurePresets, id);
    } else if (selectedIndex === 0) {
      Preset = Preset.concat(selectedBookClosurePresets.slice(1));
    } else if (selectedIndex === selectedBookClosurePresets?.length - 1) {
      Preset = Preset.concat(selectedBookClosurePresets.slice(0, -1));
    } else if (selectedIndex > 0) {
      Preset = Preset.concat(
        selectedBookClosurePresets.slice(0, selectedIndex),
        selectedBookClosurePresets.slice(selectedIndex + 1)
      );
    }
    setSelectedBookClosurePresets(Preset);
  };

  const allCoa = async () => {
    const res = await fetchCoa();
    if (res.status === 200) {
      setAllCoa(res.data.coa);
    }
  };

  const handleSelected = async () => {
    try {
      let data = {
        w_id: id,
        all_Preset_checked: selected,
      };
      const res = await CreatePresetCheck(data);
      if (res.status === 200) {
        setCheckStatus(true);
        getIr();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleBookClosureSelected = async () => {
    try {
      let data = {
        w_id: id,
        all_checked_bookclosure_presets: selectedBookClosurePresets,
      };
      const res = await CreateBookClosurePresetCheck(data);
      if (res.status === 200) {
        setCheckStatus(true);
        getIr();
        swal("Success","Presets Imported Sucessfully","success");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const CompanyName = (c_id) => {
    try {
      if (typeof c_id === "object" && c_id !== null) {
        return c_id.company_name || c_id.name || "";
      }
      const nameCompany = allCompany.filter((adj) => adj._id === c_id);
      const result = nameCompany[0]?.company_name
        ? nameCompany[0]?.company_name
        : "unknown";
      return result;
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };

  const CoaName = (p_id) => {

    const nameOfCoa = allCoaData.filter((adj) => adj.project_id === p_id);
    const result = nameOfCoa[0]?.name ? `(${nameOfCoa[0]?.name})` : "";
    return result;
  }

  const getWorkspaceDetails = async () => {
    const res = await getCheckData(id);
    if (res.status === 200) {
      setWorkspace(res.data.getIR[0])
    }
  }

  const [activeTab, setActiveTab] = useState("Presets");
  const isDisabled = user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view";

  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchExpanded, setSearchExpanded] = useState(false);
  const searchInputRef = React.useRef(null);

  const openSearch = () => {
    setShowSearch(true);
  };

  const closeSearch = () => {
    setSearchExpanded(false);
    setTimeout(() => setShowSearch(false), 600);
    setSearchText("");
  };

  useEffect(() => {
    if (showSearch) {
      const timeout = setTimeout(() => {
        setSearchExpanded(true);
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, 15);
      return () => clearTimeout(timeout);
    } else {
      setSearchExpanded(false);
    }
  }, [showSearch]);

  useEffect(() => {
    setSearchText("");
    setShowSearch(false);
    setSearchExpanded(false);
  }, [activeTab]);

  const lastPresetSearchByTabRef = React.useRef({});
  useEffect(() => {
    const search = searchText.trim();
    const tab = activeTab;
    const previousSearch = lastPresetSearchByTabRef.current[tab];
    if (previousSearch === search) return;
    if (!search && previousSearch === undefined) {
      lastPresetSearchByTabRef.current[tab] = "";
      return;
    }

    const timeout = setTimeout(() => {
      lastPresetSearchByTabRef.current[tab] = search;
      if (tab === "Presets") {
        FetchProject(search);
      } else if (tab === "BookClosure") {
        const requestId = ++bookClosureRequestIdRef.current;
        getBookClosurePresets(search)
          .then((res) => {
            if (requestId === bookClosureRequestIdRef.current && res.status === 200) {
              setBookClosurePresets(res.data?.presets || []);
            }
          })
          .catch((error) => console.error("Error searching book closure presets", error));
      }
    }, search ? 300 : 0);

    return () => clearTimeout(timeout);
  }, [searchText, activeTab]);

  const filterPreset = (p) => {
    if (!p) return false;
    const q = searchText.trim().toLowerCase();
    if (!q) return true;
    if (activeTab === "Presets") {
      const pName = p?.project_name || p?.preset_name || p?.name || "";
      const cName = CompanyName(p?.company || p?.companyID || p?.company_id) || "";
      const coa = CoaName(p?._id) || "";
      return pName.toLowerCase().includes(q) || cName.toLowerCase().includes(q) || coa.toLowerCase().includes(q);
    } else if (activeTab === "BookClosure") {
      const pName = p?.name || "";
      const cName = CompanyName(p?.companyID) || "";
      return pName.toLowerCase().includes(q) || cName.toLowerCase().includes(q);
    }
    return true;
  };

  const getActivePresetConfig = () => {
    switch (activeTab) {
      case "Presets":
        return {
          list: allProject || [],
          selected: selected || [],
          setSelected: setSelected,
        };
      case "BookClosure":
        return {
          list: bookClosurePresets || [],
          selected: selectedBookClosurePresets || [],
          setSelected: setSelectedBookClosurePresets,
        };
      default:
        return { list: [], selected: [], setSelected: () => {} };
    }
  };

  const activePresetConfig = getActivePresetConfig();
  const isAllPresetChecked =
    activePresetConfig.list.length > 0 &&
    activePresetConfig.list.every((item) =>
      activePresetConfig.selected.includes(item._id)
    );

  const handleToggleAllPreset = () => {
    if (isAllPresetChecked) {
      activePresetConfig.setSelected([]);
    } else {
      activePresetConfig.setSelected(activePresetConfig.list.map((item) => item._id));
    }
  };

  return (
    <>
      <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
        <div>
          <WSProgressBar activePage={5} id={id} />
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }} className={wsCreationcss.wsContentDiv}>
          <span className={`${wsCreationcss.wsContentHeading} mt-3 mb-1`}>
            Choose and import presets for faster configuration!
          </span>

          <div className={`${wsCreationcss.regContainer} mt-4`}>
            {/* Tabs on Top */}
            <div className={wsCreationcss.tabButtons} style={{ width:"240px" }}>
              <div
                className={`${wsCreationcss.tabButton} ${activeTab === "Presets" ? wsCreationcss.activeTab : ""}`}
                onClick={() => setActiveTab("Presets")}
              >
                {(selected?.length > 0 && checkStatus === true) || workspace?.all_preset_checked?.length > 0 ? (
                  <CircleCheckIcon className="mr-2 mb-1" />
                ) : null}
                Standalone Presets
              </div>
              <div
                className={`${wsCreationcss.tabButton} ${activeTab === "BookClosure" ? wsCreationcss.activeTab : ""}`}
                onClick={() => setActiveTab("BookClosure")}
              >
                {(selectedBookClosurePresets?.length > 0 && checkStatus === true) || workspace?.all_checked_bookclosure_presets?.length > 0 ? (
                  <CircleCheckIcon className="mr-2 mb-1" />
                ) : null}
                Book Closure Presets
              </div>
              <div
                className={`${wsCreationcss.tabButton} ${activeTab === "MIS" ? wsCreationcss.activeTab : ""}`}
                onClick={() => setActiveTab("MIS")}
              >
                MIS Presets
              </div>
            </div>

            {/* Content */}
            <div className={wsCreationcss.tabContent}>
              <div
                className={commoncss.dFlexJustifysb}
                style={{ alignItems: "center", marginBottom: "16px", minHeight: "40px", padding: "0 9px" }}
              >
                <span className={commoncss.dFlex} style={{ alignItems: "center" }}>
                  <input
                    type="checkbox"
                    id="select-all-presets"
                    checked={isAllPresetChecked}
                    onChange={handleToggleAllPreset}
                    style={{
                      margin: "0px 10px 0px 0px",
                      width: "16px",
                      height: "16px",
                      cursor: "pointer",
                    }}
                    disabled={isDisabled}
                  />
                  <label
                    htmlFor="select-all-presets"
                    style={{
                      margin: 0,
                      cursor: "pointer",
                      color: "#183930",
                      fontWeight: 500,
                      fontSize: "14px",
                    }}
                  >
                    Select all
                  </label>
                </span>

                {!showSearch && (
                  <SearchIcon
                    onClick={openSearch}
                    style={{ cursor: "pointer" }}
                  />
                )}

                {showSearch && (
                  <div className={`${wsCreationcss.searchBox} ${searchExpanded ? wsCreationcss.expanded : ""}`}>
                    <SearchIcon className={wsCreationcss.searchInside} />
                    <input
                      ref={searchInputRef}
                      type="text"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Search..."
                      className={wsCreationcss.searchInput}
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          closeSearch();
                        }
                      }}
                    />
                    <CloseGreyIcon
                      style={{ cursor: "pointer" }}
                      onClick={closeSearch}
                    />
                  </div>
                )}
              </div>

              {activeTab === "Presets" && (
                <>
                  <div className={`${wsCreationcss.scrollArea} ml-2`}>
                    {allProject?.length > 0 &&
                      allProject.filter(filterPreset).map((det) => {
                        const { _id } = det;
                        const selectedUser = selected?.includes(_id);
                        return (
                          <>
                            <div className="d-flex mb-2" key={_id} style={{ "align-items": "center" }}>
                              <input
                                style={{ "margin": "-20px 20px 0px 0px" }}
                                type="checkbox"
                                checked={selectedUser}
                                disabled={isDisabled}
                                onChange={(event) =>
                                  handleChangePreset("check_company", event, _id)
                                }
                              />
                              <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "90%", "margin-bottom": "15px" }}>
                                <div className={commoncss.dFlexClm}>
                                  <span className={wsCreationcss.wscLabel2}>
                                    {det.project_name || det.preset_name || det.name || "unknown"} {CoaName(det._id)}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {CompanyName(det.company || det.companyID || det.company_id)}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ "gap": "14px" }}>
                                  <div className={wsCreationcss.wscCard1}>
                                    <span className={wsCreationcss.wscLabel4}>PY</span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {det.previous_year ? moment(det.previous_year).format("DD-MMM-YYYY") : ""}
                                    </span>
                                  </div>
                                  {/* <div className={wsCreationcss.wscCard1}>
                                    <span className={wsCreationcss.wscLabel4}>Created</span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {det.createdAt ? moment(det.createdAt).format("DD-MMM-YYYY") : ""}
                                    </span>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                  </div>

                  <hr />
                  <div className="d-flex">
                    <button
                      className={wsCreationcss.saveBtn}
                      onClick={handleSelected}
                      disabled={isDisabled}
                    >
                      Import selected Preset
                    </button>
                    <button
                      className={`${wsCreationcss.perviewBtn} ml-2`}
                      onClick={handleSelectAllClick}
                      disabled={isDisabled}
                    >
                      Import all Preset
                    </button>
                  </div>
                </>
              )}
              {activeTab === "BookClosure" && (
                <>
                  <div className={`${wsCreationcss.scrollArea} ml-2`}>
                    {bookClosurePresets?.length > 0 &&
                      bookClosurePresets.filter(filterPreset).map((bookClosurePreset) => {
                        const { _id } = bookClosurePreset;
                        const selectedUser = selectedBookClosurePresets?.includes(_id);
                        return (
                          <>
                            <div className="d-flex mb-2" key={_id} style={{ "align-items": "center" }}>
                              <input
                                style={{ "margin": "-20px 20px 0px 0px" }}
                                type="checkbox"
                                checked={selectedUser}
                                disabled={isDisabled}
                                onChange={(event) =>
                                  handleBookClosurePreset("check_company", event, _id)
                                }
                              />
                              <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "90%", "margin-bottom": "15px" }}>
                                <div className={commoncss.dFlexClm}>
                                  <span className={wsCreationcss.wscLabel2}>
                                    {bookClosurePreset.name || "unknown"}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {CompanyName(bookClosurePreset.companyID)}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ "gap": "14px" }}>
                                  <div className={wsCreationcss.wscCard1}>
                                    <span className={wsCreationcss.wscLabel4}>Created on</span>
                                    <span className={wsCreationcss.wscLabel5}>{moment(bookClosurePreset.createdAt).format("DD-MMM-YYYY")}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                  </div>

                  <hr />
                  <div className="d-flex">
                    <button
                      className={wsCreationcss.saveBtn}
                      onClick={handleBookClosureSelected}
                      disabled={isDisabled}
                    >
                      Import selected Preset
                    </button>
                    <button
                      className={`${wsCreationcss.perviewBtn} ml-2`}
                      onClick={handleSelectAllBookClosurePresets}
                      disabled={isDisabled}
                    >
                      Import all Preset
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </motion.div>
        <div className={wsCreationcss.footerContainer}>
          <div>
            <button
              onClick={() => history.push(`/dashboard`)}
              className={wsCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
          </div>
          <div className={wsCreationcss.footerbtnContainer}>
            <span className={wsCreationcss.skipForNow} 
                  onClick={skipNext} >Skip for now</span>
            <button
              className={wsCreationcss.perviewBtn} onClick={() => history.push(`/importregister/${id}`)}
              type="button" style={{ "padding": "7px" }}><PervBtnIcon height={19} />Previous</button>

            <button onClick={nextStep} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>Next<RightIcon height={12} /></button>


          </div>
        </div>
      </div>
    </>
  );
};
export default ImportPresetV2;
